<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :itemNames="['search_name','create_button',]"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_name" label="供应商名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.supplyName" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="onPageSearch">查 询</a-button>
        <a-button style="margin-left:15px" @click="onAddAccount">添加供应商</a-button>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a @click="onEventAccount(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status==1" @click="onEventUpdate(rowItem.record.accountId,0)">禁用</a>
        <a v-else @click="onEventUpdate(rowItem.record.accountId,1)">启用</a>
      </template>
    </search-page-view>
    <a-modal title="添加供应商" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="供应商名称" prop="supplyName">
          <a-input v-model.trim="ruleForm.supplyName" placeholder="请输入供应商名称" allowClear :maxLength="40"/>
        </a-form-model-item>
        <a-form-model-item label="URL" prop="supplyUrl">
          <a-input v-model.trim="ruleForm.supplyUrl" placeholder="请输入URL" allowClear :maxLength="250"/>
        </a-form-model-item>
        <a-form-model-item label="渠道ID" prop="appId">
          <a-input v-model.trim="ruleForm.appId" placeholder="请输入渠道ID" allowClear :maxLength="250"/>
        </a-form-model-item>
        <a-form-model-item label="秘钥" prop="secret">
          <a-input v-model.trim="ruleForm.secret" placeholder="请输入秘钥" allowClear :maxLength="250"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>

import ChaoMaiMixins from '@/views/service/serviceProvider/chaoMaiCloud/mixins/ChaoMaiMixins'
import moment from 'moment'

export default {
  name: 'ChaoMaiStores',
  mixins: [ChaoMaiMixins],
  components: {},
  data() {
    return {
      moment,
      submitLoading: false,
      dialogVisible: false,
      ruleForm: {
        accountId: undefined,
        appId: '',// appId ,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        secret: '',// 秘钥 ,
        supplyName: '',// 供应商名称 ,
        supplyUrl: ''// 供应商接口地址
      },
      rules: {
        supplyName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        supplyUrl: [
          { required: true, message: '请输入URL', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入渠道ID', trigger: 'blur' }
        ],
        secret: [
          { required: true, message: '请输入秘钥', trigger: 'blur' }
        ]
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        supplyName: ''
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
  },
  methods: {
    onPageSearch() {
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      // this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('cmyp/account/list/page', params)
    },
    handleCancel() {
      this.dialogVisible = false
      this.popupVisible = false
      this.visible = false
      this.uploadVisible = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //同步店铺
    submitData() {
      this.submitLoading = true
      const params = JSON.parse(JSON.stringify(this.ruleForm))
      const path = params.accountId ? 'cmyp/account/update' : 'cmyp/account/add'
      this.getHttpServices().getServerApiService().post(path, params).then(res => {
        this.getLogUtils().logWithTag('submitSyncStoreData', res)
        this.$message.success('添加供应商成功')
        this.handleCancel()
        this.onPageSearch()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onAddAccount() {
      this.dialogVisible = true
      this.ruleForm.accountId = undefined
      this.ruleForm.appId = ''// appId ,
      this.ruleForm.secret = ''// 秘钥 ,
      this.ruleForm.supplyName = ''// 供应商名称 ,
      this.ruleForm.supplyUrl = ''// 供应商接口地址
    },
    onEventAccount(record) {
      this.dialogVisible = true
      this.ruleForm.accountId = record.accountId
      this.ruleForm.appId = record.appId// appId ,
      this.ruleForm.secret = record.secret// 秘钥 ,
      this.ruleForm.supplyName = record.supplyName// 供应商名称 ,
      this.ruleForm.supplyUrl = record.supplyUrl// 供应商接口地址
    },
    onEventUpdate(accountId, status) {
      let params = {
        accountId: accountId,
        status: status
      }
      this.getHttpServices().getServerApiService().post('cmyp/account/status/update', params).then(res => {
        this.$refs.table.refresh(true)
        this.$message.success('状态更新成功')
      }).catch(err => {
        this.getLogUtils().logWithTag('onUpdateEvent', err)
      })
    },
    getColumns() {
      return [
        {
          title: '供应商ID',
          dataIndex: 'accountId'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplyName'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '170px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.right-box {
  text-align: right;
}

.line-font {
  padding-top: 5px;
  line-height: 28px;
}

.selected-image {
  width: 100px;
  height: 100px;
}

.display-main {
  display: flex;
  align-items: center;

  .line-text {
    flex-shrink: 0;
    width: 230px;
    line-height: 18px;
    font-size: 14px;
  }
}
</style>